// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3sCMU","additionalInfo":"AgreementModal_additionalInfo__1Zr6v"};